import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { UserListStatisticsResponse } from '~/models/common';
import { getUserListStatistics } from '~/services/userStatisticsService';
import { thunkAction } from '~/utils/utils';

type UserStatisticsState = {
  statistics: UserListStatisticsResponse | null;
  lastFetchedAt: number | null;
  error: unknown;
  loading: boolean;
};

const initialState: UserStatisticsState = {
  statistics: null,
  lastFetchedAt: null,
  error: {},
  loading: false,
};

export const fetchUserListStatistics = createAsyncThunk(
  'userStatistics/fetch',
  thunkAction(async () => {
    const res = await getUserListStatistics();
    return res?.data?.getUserListStatistics as UserListStatisticsResponse;
  }),
);

const userStatisticsSlice = createSlice({
  name: 'userStatistics',
  initialState,
  reducers: {
    clearUserStatistics(state) {
      state.statistics = null;
      state.lastFetchedAt = null;
    },
  },
  extraReducers(builder) {
    builder.addCase(fetchUserListStatistics.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchUserListStatistics.fulfilled, (state, action) => {
      state.loading = false;
      state.statistics = action.payload ?? null;
      state.lastFetchedAt = Date.now();
    });
    builder.addCase(fetchUserListStatistics.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload ?? action.error;
    });
  },
});

export const { clearUserStatistics } = userStatisticsSlice.actions;
export default userStatisticsSlice.reducer;
